import { createContext } from 'react';

export interface HeaderNavgiationContextProps {
  /**
   * Used to determine which overlay nav menu is currently open.
   * @default ''
   */
  activeMenuID?: string;
  /**
   * Function to toggle the current active overlay nav menu by id
   */
  setActiveMenuID?: (id: string) => void;
}

export const HeaderNavigationContext = createContext<HeaderNavgiationContextProps>({
  activeMenuID: '',
  setActiveMenuID: () => {},
});
